
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"32","height":"32","rx":"4","fill":"#0077FF"}}),_c('path',{attrs:{"d":"M17.3485 21.8111C10.8569 21.8111 7.15428 17.4526 7 10.2H10.2517C10.3585 15.5232 12.7557 17.778 14.6545 18.2429V10.2H17.7165V14.791C19.5916 14.5934 21.5613 12.5013 22.2259 10.2H25.2878C24.7775 13.036 22.6414 15.128 21.1223 15.9881C22.6414 16.6855 25.0743 18.5103 26 21.8111H22.6295C21.9056 19.6028 20.1019 17.8942 17.7165 17.6618V21.8111H17.3485Z","fill":"white"}})])
          )
        }
      }
    